// src/constants/index.ts
export const API_ROOT = 'https://newsfeedapi.ermacaz.com';
// export const API_ROOT = 'http://localhost:3000';
export const HEADERS: Record<string, string> = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
